import type { ReactNode } from "react";

/**
 * @description
 * Unwrapped children (including those wrapped in <></>) are not handled correctly by chrome translator causing "Failed to execute 'insertBefore' on 'Node'" errors.
 * This component is used to wrap the children for translator compatibility.
 * @param children - The children to be wrapped.
 * @returns The wrapped children.
 */
export function TranslateGuard({ children }: { children: ReactNode | string | undefined }) {
	return (
		<span
			style={{ color: "inherit", display: "inline", font: "inherit", lineHeight: "inherit" }}
		>
			{children}
		</span>
	);
}
